var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83D\uDD39 Icon Color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.8.-Exclusion-Filters---Liquidity---08",
    transform: "translate(-533.000000, -95.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Title",
    transform: "translate(252.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(280.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625,6.125 L11.375,6.125 L11.375,7.875 L9.625,7.875 L9.625,6.125 Z M9.625,9.625 L11.375,9.625 L11.375,14.875 L9.625,14.875 L9.625,9.625 Z M10.5,1.75 C5.67,1.75 1.75,5.67 1.75,10.5 C1.75,15.33 5.67,19.25 10.5,19.25 C15.33,19.25 19.25,15.33 19.25,10.5 C19.25,5.67 15.33,1.75 10.5,1.75 Z M10.5,17.5 C6.64125,17.5 3.5,14.35875 3.5,10.5 C3.5,6.64125 6.64125,3.5 10.5,3.5 C14.35875,3.5 17.5,6.64125 17.5,10.5 C17.5,14.35875 14.35875,17.5 10.5,17.5 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.92e4d7ec.svg";
export { ForwardRef as ReactComponent };